import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross and Blue Shield",
  shortName: "Anthem",
  slug: "anthem-general-insurance",
  seoTitle:
    "Anthem Blue Cross and Blue Shield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Anthem Blue Cross and Blue Shield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Anthem TMS coverage, Anthem SPRAVATO authorization, Anthem mental health benefits Coral Springs FL, Anthem depression treatment Florida",
};

export const AnthemGeneralInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemGeneralInsurance;
